export default class ModaleChooseDestinataireController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'ModalService',
		'ConfigurationEmailService',
		'ConfigurationEmailUtilsService',
		'notification',
		'$translate',
		'$filter',
		'_',
		'$uibModal'
	];
	constructor(
		$scope,
		$state,
		$stateParams,
		ModalService,
		ConfigurationEmailService,
		ConfigurationEmailUtilsService,
		notification,
		$translate,
		$filter,
		_,
		$uibModal
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.ModalService = ModalService;
		this.ConfigurationEmailService = ConfigurationEmailService;
		this.ConfigurationEmailUtilsService = ConfigurationEmailUtilsService;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this._ = _;
		this.$uibModal = $uibModal;
		this.loading = false;
		this.isSmtpOk = false;
		this.selectedFactures = [];
		this.mailNonCorrectCount = 0;
		this.mailNonRenseigneCount = 0;
		this.selectAll = false;
		this.contacts = [];
		this.selectedContacts = [];
	}

	async $onInit() {
		if (this.resolve.idSociete > 0) {
			await this.loadConfigurationSmtp(this.resolve.idSociete);
		}
		this.selectedFactures = this.resolve.selectedFactures;
		if (this.selectedFactures.length > 0) {
			const idsFactures = this.selectedFactures.map((facture) => facture.id);
			await this.loadContacts(idsFactures);
			this.preselectContact();
		}
	}

	async loadContacts(idsFactures) {
		this.startLoading();
		try {
			const contacts = await this.ConfigurationEmailService.getContactsByFactures(idsFactures);
			this.selectedFactures.forEach((facture) => {
				facture.contacts = contacts.filter((contact) => contact.idFactureLie === facture.id);
			});
		} catch (error) {
			this.notification.error('CONFIGURATION_EMAIL.FORM.CONFIGURATION_NOT_FOUND');
		}
		this.stopLoading();
	}

	async loadConfigurationSmtp(idSociete) {
		this.startLoading();
		try {
			const configSmtp = await this.ConfigurationEmailService.getConfigurationSmtpBySociete(idSociete);
			if (configSmtp && this.ConfigurationEmailUtilsService.isSmtpConfigValide(configSmtp)) {
				this.isSmtpOk = true;
			} else {
				this.isSmtpOk = false;
			}
		} catch (error) {
			this.notification.error('CONFIGURATION_EMAIL.FORM.CONFIGURATION_NOT_FOUND');
		}
		this.stopLoading();
	}

	selectContact(contact) {
		this.selectAll = false;
		contact.selected = !contact.selected;
	}

	selectAllContacts() {
		this.selectAll = !this.selectAll;
		this.contacts.forEach((contact) => {
			if (!contact.isEmailNotCorrect && !contact.isEmailNotRenseigne) {
				contact.selected = this.selectAll;
			}
		});
	}

	showContacts(facture) {
		this.selectAll = false;
		this.mailNonCorrectCount = 0;
		this.mailNonRenseigneCount = 0;
		this.contacts = [...facture.contacts];
		this.contacts.forEach((contact) => {
			if (contact.isEmailNotCorrect && !contact.isEmailNotRenseigne) {
				this.mailNonCorrectCount++;
			}
			if (contact.isEmailNotRenseigne) {
				this.mailNonRenseigneCount++;
			}
		});
	}

	removeFacture(facture) {
		this.selectedFactures = this.selectedFactures.filter((fa) => fa.id !== facture.id);
	}

	async send() {
		const contactsToSend = this.selectedFactures.flatMap((facture) => facture.contacts.filter((contact) => contact.selected));
		this.ok(contactsToSend);
	}

	ok(contacts) {
		this.close({
			$value: contacts
		});
	}

	cancel() {
		this.dismiss();
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	preselectContact() {
		this.selectedFactures.forEach((facture) => {
			if (facture.contacts.length > 0) {
				facture.contacts.forEach((contact) => {
					if (!contact.isEmailNotCorrect && !contact.isEmailNotRenseigne) {
						contact.selected = true;
					}
				});
			}
		});
	}
}
